import { BaseElement } from '@adobe/edex/ui/components/base.element';
import { customElement, html } from '@adobe/edex/ui/edex-lit';
import { EdexTagName } from '@adobe/edex/ui/shared/constants';
import styles from './single-otp-input.lit.scss';

@customElement(EdexTagName.singleOtpInput)
export class SingleOtpInput extends BaseElement {
  static get properties() {
    return {
      ...super.properties,
      value: { type: String },
      isLastChild: { type: Boolean },
      autoFocus: { type: Boolean },
      focusElement: { type: Boolean },
    };
  }
  static styles = styles;
  value = '';
  isLastChiled: boolean;
  autoFocus = true;
  focusElement: boolean;
  i = -1;

  get input() {
    return this.shadowRoot.querySelector('input');
  }

  updated(changedProperties) {
    if (changedProperties.has('focusElement') && this.focusElement && this.input) {
      this.input.focus();
      this.input.select();
    }
  }

  handlePaste = (event) => {
    this.emitEvent('onPaste', { event });
  };

  handleFocus = () => {
    this.input.select();
    this.emitEvent('focusClick');
  };

  handleChange = (event) => {
    event.stopPropagation();
    const {
      target: { value },
    } = event;
    this.emitEvent('onChange', { value });
  };

  handleKeyDown = (event) => {
    this.emitEvent('onKeyDown', { event });
  };

  render() {
    const { value } = this;
    return html`
      <input
        class="single-otp-input"
        min="0"
        max="9"
        maxlength="1"
        pattern="[0-9]"
        .value=${value}
        @paste=${this.handlePaste}
        @input=${this.handleChange}
        @focus=${this.handleFocus}
        @keydown=${this.handleKeyDown}
      />
    `;
  }
}
